/**
 * Created by Konstantino on 29/9/16.
 */
'use strict';

angular.module('meanApp')
  .config(function ($stateProvider) {
    $stateProvider
      .state('property-assets', {
        url: '/property-assets/:clientId',
        params: {
          clientId: {
            value: null,
            squash: false
          }
        },
        templateUrl: 'app/assets/property-assets.html',
        controller: 'factfind-3-controller',
        authenticate: ['user','admin']
      });
  })


  .config(function ($stateProvider) {
    $stateProvider
      .state('other-assets', {
        url: '/other-assets/:clientId',
        params: {
          clientId: {
            value: null,
            squash: false
          }
        },
        templateUrl: 'app/assets/other-assets.html',
        controller: 'factfind-4-controller',
        authenticate: ['user','admin']
      });
  });

